<ng-container [ngTemplateOutlet]="isCustom ? customIcon : materialIcon"></ng-container>
<!-- vlIcon -->
<ng-template #customIcon><ng-container [ngComponentOutlet]="currentComponent"></ng-container></ng-template>
<!-- Angular Material -->
<ng-template #materialIcon>
	<mat-icon>
		{{ name }}
	</mat-icon>
</ng-template>
